var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 19,
    viewBox: "0 0 27 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28549 16.6051H3.12156V17.8451H7.28549V16.6051Z",
    fill: "#C0DEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1923 16.6051H19.9151V17.8451H24.1923V16.6051Z",
    fill: "#C0DEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4515 6.06426H14.7649L21.0237 0.053833H18.7103L12.4515 6.06426Z",
    fill: "#C0DEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94517 6.06426H10.2456L16.5044 0.053833H11.2051L4.94517 6.06426Z",
    fill: "#C0DEFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7168 13.489V7.25789C24.7168 6.89838 24.4131 6.60669 24.0387 6.60669L15.5663 7.90909H11.4976L3.02515 6.60669C2.65079 6.60669 2.34704 6.89838 2.34704 7.25789V13.4879C2.34704 13.8474 2.65079 14.1391 3.02515 14.1391H24.0398C24.4131 14.1402 24.7168 13.8485 24.7168 13.489Z",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.998 14.1402H1.35623C1.29459 14.1402 1.24415 14.1886 1.24415 14.2478V16.4974C1.24415 16.5566 1.29459 16.6051 1.35623 16.6051H25.9991C26.0607 16.6051 26.1112 16.5566 26.1112 16.4974V14.2478C26.1101 14.1886 26.0607 14.1402 25.998 14.1402Z",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12156 16.6051V18.8063C3.12156 18.8838 3.18657 18.9462 3.26727 18.9462H7.1409C7.22161 18.9462 7.28661 18.8838 7.28661 18.8063V16.6051",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9723 16.6051V18.8063C19.9723 18.8838 20.0373 18.9462 20.118 18.9462H23.9916C24.0724 18.9462 24.1374 18.8838 24.1374 18.8063V16.6051",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89256 9.78198H11.0672",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9269 9.78198H13.1015",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.137 9.78198H13.9623",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1713 9.78198H15.9967",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89256 11.7356H11.0672",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9269 11.7356H13.1015",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9623 11.7356H15.137",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9967 11.7356H17.1713",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5171 4.43353C24.7292 4.43353 24.0903 5.04706 24.0903 5.80375C24.0903 6.56043 24.7292 7.17396 25.5171 7.17396C26.3051 7.17396 26.944 6.56043 26.944 5.80375C26.944 5.04706 26.3051 4.43353 25.5171 4.43353Z",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1.48287 4.43353C0.694919 4.43353 0.0560379 5.04706 0.0560379 5.80375C0.0560379 6.56043 0.694919 7.17396 1.48287 7.17396C2.27082 7.17396 2.90971 6.56043 2.90971 5.80375C2.91083 5.04706 2.27195 4.43353 1.48287 4.43353Z",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0387 6.06423L21.5056 0.449913C21.3969 0.208807 21.1492 0.0527344 20.8757 0.0527344H6.18818C5.9147 0.0527344 5.66699 0.208807 5.55827 0.449913L3.02516 6.06423H24.0387Z",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0591 12.1974V9.48389H18.9893V12.1974",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13844 12.1974V9.48389H4.06979V12.1974",
    stroke: "#3D96FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.03664b79.svg";
export { ForwardRef as ReactComponent };